export const productBrand = {
  name: "PaperbackOS",
  shortName: "PaperbackOS",
  spokenName: "Paperback",
  tagline: "The bookstore operating system for independent shops.",
  budgetTagline: "Serious bookstore software built for indie-bookstore budgets.",
  website: "https://paperbackos.com",
  websiteLabel: "paperbackos.com",
  icon: "/brand/paperbackos-icon.png",
  wordmark: "/brand/paperbackos-wordmark.png",
  wordmarkInverse: "/brand/paperbackos-wordmark-inverse.png",
} as const;
